$(document).ready(function(){
  $(".accordion.product--wrapper .accordion-header").click(function(){
    // Close all other accordions
    $(".accordion.product--wrapper .accordion-content").slideUp();
    $(".accordion.product--wrapper .icon").text("+");

    // If the clicked one is not already open, open it
    if(!$(this).next(".accordion-content").is(":visible")){
      $(this).next(".accordion-content").slideDown();
      $(this).find(".icon").text("-");
    }
  });
});

 
